import { Modal } from 'react-bootstrap';
import { HashLink } from 'react-router-hash-link';

//Sources
import AboutSourcesGda from './AboutSections/AboutSourcesGda.jsx';
import AboutSourcesVda from './AboutSections/AboutSourcesVda.jsx';
import AboutSourcesDda from './AboutSections/AboutSourcesDda.jsx';

//Metrics
import AboutMetricsGdaScore from './AboutSections/Metrics/AboutMetricsGdaScore.jsx';
import AboutMetricsVdaScore from './AboutSections/Metrics/AboutMetricsVdaScore.jsx';
import AboutMetricsSpecificity from './AboutSections/Metrics/AboutMetricsSpecificity.jsx';
import AboutMetricsPleiotropy from './AboutSections/Metrics/AboutMetricsPleiotropy.jsx';
import AboutMetricsEvidenceIndex from './AboutSections/Metrics/AboutMetricsEvidenceIndex.jsx';

// import AboutAttributesGenes from './AboutSections/Attributes/AboutAttributesGenes/AboutAttributesGenes.jsx';
// import AboutAttributesVariants from './AboutSections/Attributes/AboutAttributesVariants/AboutAttributesVariants.jsx';
// import AboutAttributesDiseases from './AboutSections/Attributes/AboutAttributesDiseases/AboutAttributesDiseases.jsx';
// import AboutAttributesChemicals from './AboutSections/Attributes/AboutAttributesChemicals.jsx';
// import AboutAttributesGeneDisease from './AboutSections/Attributes/AboutAttributesGeneDisease/AboutAttributesGeneDisease.jsx';
// import AboutAttributesVariantDisease from './AboutSections/Attributes/AboutAttributesVariantDisease.jsx';
// import AboutAttributesDiseaseDisease from './AboutSections/Attributes/AboutAttributesDiseaseDisease.jsx';

//Diseases
import DiseaseType from './AboutSections/Attributes/Diseases/DiseaseType.jsx';
import DO from './AboutSections/Attributes/Diseases/DO.jsx';
import MeSHDiseaseClass from './AboutSections/Attributes/Diseases/MeSHDiseaseClass.jsx';
import HPO from './AboutSections/Attributes/Diseases/HPO.jsx';

//Gene Disease
import FirstRef from './AboutSections/Attributes/GeneDisease/FirstRef.jsx';
import LastRef from './AboutSections/Attributes/GeneDisease/LastRef.jsx';
import OriginalDB from './AboutSections/Attributes/GeneDisease/OriginalDB.jsx';
import GenePMID from './AboutSections/Attributes/GeneDisease/GenePMID.jsx';
import EvidenceLevel from './AboutSections/Attributes/GeneDisease/EvidenceLevel.jsx';

//Genes
import GenespLI from './AboutSections/Attributes/Genes/GenespLI.jsx';
import GenesProteinClass from './AboutSections/Attributes/Genes/GenesProteinClass.jsx';
import GenesUniProt from './AboutSections/Attributes/Genes/GenesUniProt.jsx';

//Variants
import Position from './AboutSections/Attributes/Variants/Position.jsx';
import Type from './AboutSections/Attributes/Variants/Type.jsx';
import RiskAllele from './AboutSections/Attributes/Variants/RiskAllele.jsx';
import Consequence from './AboutSections/Attributes/Variants/Consequence.jsx';
import Alleles from './AboutSections/Attributes/Variants/Alleles.jsx';
import GenomeExome from './AboutSections/Attributes/Variants/Genome-Exome.jsx';

//Variant Disease
import PMID from './AboutSections/Attributes/VarianDiseases/PMID.jsx';
import PValue from './AboutSections/Attributes/VarianDiseases/PValue.jsx';

function HelpPopups({
  // showMetrics,
  // setShowMetrics,
  // showAttributes,
  // setShowAttributes,

  // Sources
  showGDA,
  setShowGDA,
  showVDA,
  setShowVDA,
  showDDA,
  setShowDDA,

  // Metrics
  showScore,
  setShowScore,
  showDSI,
  setShowDSI,
  showDPI,
  setShowDPI,
  showEI,
  setShowEI,

  // Diseases
  showDiseaseType,
  setShowDiseaseType,
  showMeSH,
  setShowMeSH,
  showDO,
  setShowDO,
  showHPO,
  setShowHPO,

  // Genes
  showpLI,
  setShowpLI,
  showProteinClass,
  setShowProteinClass,
  showUniProt,
  setShowUniProt,

  // Variants
  showVariantPosition,
  setShowVariantPosition,
  showVariantType,
  setShowVariantType,
  showVariantRiskAllele,
  setShowVariantRiskAllele,
  showVariantConsequence,
  setShowVariantConsequence,
  showAlleles,
  setShowAlleles,
  showGenomeExome,
  setShowGenomeExome,

  // Gene-Disease Associations && Variant-Disease Associations
  showFirstRef,
  setShowFirstRef,
  showLastRef,
  setShowLastRef,
  showEvidenceLevel,
  setShowEvidenceLevel,
  showOriginalDB,
  setShowOriginalDB,
  showPMID,
  setShowPMID,
  showpValue,
  setShowpValue,
}) {
  return (
    <>
      {/* Sources */}

      <Modal show={showGDA} onHide={() => setShowGDA(false)}>
        <Modal.Body>
          <AboutSourcesGda />
        </Modal.Body>
      </Modal>

      <Modal show={showVDA} onHide={() => setShowVDA(false)}>
        <Modal.Body>
          <AboutSourcesVda />
        </Modal.Body>
      </Modal>

      <Modal show={showDDA} onHide={() => setShowDDA(false)}>
        <Modal.Body>
          <AboutSourcesDda />
        </Modal.Body>
      </Modal>

      {/* Metrics */}

      <Modal show={showScore} onHide={() => setShowScore(false)}>
        <Modal.Body>
          <div>
            <AboutMetricsGdaScore />
            <div className="divider" />
            <AboutMetricsVdaScore />
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showDSI} onHide={() => setShowDSI(false)}>
        <Modal.Body>
          <AboutMetricsSpecificity />
        </Modal.Body>
      </Modal>

      <Modal show={showDPI} onHide={() => setShowDPI(false)}>
        <Modal.Body>
          <AboutMetricsPleiotropy />
        </Modal.Body>
      </Modal>

      <Modal show={showEI} onHide={() => setShowEI(false)}>
        <Modal.Body>
          <AboutMetricsEvidenceIndex />
        </Modal.Body>
      </Modal>

      {/* Data Attributes Diseases */}

      <Modal show={showDiseaseType} onHide={() => setShowDiseaseType(false)}>
        <Modal.Body>
          <DiseaseType />
        </Modal.Body>
      </Modal>

      <Modal show={showDO} onHide={() => setShowDO(false)}>
        <Modal.Body>
          <DO />
        </Modal.Body>
      </Modal>

      <Modal show={showHPO} onHide={() => setShowHPO(false)}>
        <Modal.Body>
          <HPO />
        </Modal.Body>
      </Modal>

      <Modal show={showMeSH} onHide={() => setShowMeSH(false)}>
        <Modal.Body>
          <MeSHDiseaseClass />
        </Modal.Body>
      </Modal>

      {/* Data Attributes Genes */}

      <Modal show={showpLI} onHide={() => setShowpLI(false)}>
        <Modal.Body>
          <GenespLI />
        </Modal.Body>
      </Modal>

      <Modal show={showProteinClass} onHide={() => setShowProteinClass(false)}>
        <Modal.Body>
          <GenesProteinClass />
        </Modal.Body>
      </Modal>

      <Modal show={showUniProt} onHide={() => setShowUniProt(false)}>
        <Modal.Body>
          <GenesUniProt />
        </Modal.Body>
      </Modal>

      {/* Data Attributes Variants */}

      <Modal show={showVariantPosition} onHide={() => setShowVariantPosition(false)}>
        <Modal.Body>
          <Position />
        </Modal.Body>
      </Modal>

      <Modal show={showVariantType} onHide={() => setShowVariantType(false)}>
        <Modal.Body>
          <Type />
        </Modal.Body>
      </Modal>

      <Modal show={showAlleles} onHide={() => setShowAlleles(false)}>
        <Modal.Body>
          <Alleles />
        </Modal.Body>
      </Modal>

      <Modal show={showVariantRiskAllele} onHide={() => setShowVariantRiskAllele(false)}>
        <Modal.Body>
          <RiskAllele />
        </Modal.Body>
      </Modal>

      <Modal show={showVariantConsequence} onHide={() => setShowVariantConsequence(false)}>
        <Modal.Body>
          <Consequence />
        </Modal.Body>
      </Modal>

      <Modal show={showGenomeExome} onHide={() => setShowGenomeExome(false)}>
        <Modal.Body>
          <GenomeExome />
        </Modal.Body>
      </Modal>

      {/* Data Attributes Gene-Disease Associations && Data Attributes Variant-Disease Associations */}

      <Modal show={showFirstRef} onHide={() => setShowFirstRef(false)}>
        <Modal.Body>
          <FirstRef />
        </Modal.Body>
      </Modal>

      <Modal show={showLastRef} onHide={() => setShowLastRef(false)}>
        <Modal.Body>
          <LastRef />
        </Modal.Body>
      </Modal>

      <Modal show={showEvidenceLevel} onHide={() => setShowEvidenceLevel(false)}>
        <Modal.Body>
          <EvidenceLevel />
        </Modal.Body>
      </Modal>

      <Modal show={showOriginalDB} onHide={() => setShowOriginalDB(false)}>
        <Modal.Body>
          <OriginalDB />
        </Modal.Body>
      </Modal>

      <Modal show={showPMID} onHide={() => setShowPMID(false)}>
        <Modal.Body>
          <PMID />
          <GenePMID />
        </Modal.Body>
      </Modal>

      <Modal show={showpValue} onHide={() => setShowpValue(false)}>
        <Modal.Body>
          <PValue />
        </Modal.Body>
      </Modal>
    </>
  );
}

export default HelpPopups;
